package com.wintermar.inspection.core.ui.component.input.util

import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.TextFieldColors
import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

object InputColor {

    @Composable
    fun default(): TextFieldColors {
        val color = LocalAppTheme.current.color

        return OutlinedTextFieldDefaults.colors().copy(
            focusedContainerColor = color.surface.input.default,
            focusedIndicatorColor = color.border.input.focused,
            focusedTextColor = color.text.default,
            focusedSupportingTextColor = color.text.subtlest,
            focusedPrefixColor = color.text.subtlest,
            focusedSuffixColor = color.text.default,
            focusedTrailingIconColor = color.icon.subtlest,
            focusedLeadingIconColor = color.icon.subtlest,
            focusedPlaceholderColor = color.text.subtlest,

            unfocusedContainerColor = color.surface.input.default,
            unfocusedIndicatorColor = color.border.input.default,
            unfocusedSupportingTextColor = color.text.subtlest,
            unfocusedPrefixColor = color.text.subtlest,
            unfocusedSuffixColor = color.text.default,
            unfocusedTrailingIconColor = color.icon.subtlest,
            unfocusedLeadingIconColor = color.icon.subtlest,
            unfocusedPlaceholderColor = color.text.subtlest,

            disabledContainerColor = color.surface.input.disabled,
            disabledIndicatorColor = color.border.input.disabled,
            disabledTextColor = color.text.disabled,
            disabledSupportingTextColor = color.text.subtlest,
            disabledPrefixColor = color.text.disabled,
            disabledSuffixColor = color.text.disabled,
            disabledTrailingIconColor = color.icon.disabled,
            disabledLeadingIconColor = color.icon.disabled,
            disabledPlaceholderColor = color.text.subtlest,

            errorContainerColor = color.surface.input.default,
            errorIndicatorColor = color.border.input.error,
            errorTextColor = color.text.default,
            errorSupportingTextColor = color.text.error.default,
            errorPrefixColor = color.text.subtlest,
            errorSuffixColor = color.text.default,
            errorTrailingIconColor = color.icon.subtlest,
            errorLeadingIconColor = color.icon.subtlest,
            errorPlaceholderColor = color.text.subtlest,
        )
    }
}
